import http from '@root/utils/axios/admin';

let state = {
    CardStatusesList: [],
    CardStatus: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCardStatusesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/card-statuses', { params: filter }).then((response) => {
                commit('setCategories', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCardStatus({ commit }, id) {
        return http.delete('/api/card-statuses/' + id);
    },

    fetchCardStatus({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/card-statuses/' + id).then((response) => {
                commit('setCardStatus', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCardStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/card-statuses', data).then((response) => {
                commit('setCardStatus', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardStatusError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateCardStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/card-statuses/' + data.id, data).then((response) => {
                commit('setCardStatus', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardStatusError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCategories(state, data) {
        state.CardStatusesList = data;
    },
    setCardStatus(state, data) {
        state.CardStatus.data = data;
    },
    setCardStatusError(state, error) {

        state.CardStatus.error = error.errors;
    },
    cleanCardStatusError(state, error) {
        state.CardStatus.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}